/**
 * Sim Racing Connected brand mark — image-based logo.
 * Uses the official SRC / SIM RACING CONNECTED horizontal artwork.
 */

const LOGO_SRC =
  "https://customer-assets-agu9un31.emergentagent.net/job_140d9c64-db2c-4907-8f79-3f079e2743ed/artifacts/x1pnllq7_SRC%20Web%20icon%20%282%29.png";

export default function Logo({ size = "md", className = "" }) {
  const heights = {
    sm: "h-8",
    md: "h-10",
    lg: "h-16",
    xl: "h-20",
  };
  const h = heights[size] || heights.md;
  return (
    <img
      src={LOGO_SRC}
      alt="Sim Racing Connected"
      className={`${h} w-auto select-none ${className}`}
      draggable={false}
    />
  );
}
